import React from 'react'
import style from './style.module.css'
import classNames from 'classnames'
import { KeenSliderInstance } from 'keen-slider'

type Props = {
  dir: 'left' | 'right'
  background: 'dark' | 'light'
  arrow: 'dark'
  variation?: 'dots-beneath'
  disabled?: boolean
  parent?: string
  instanceRef1?: React.MutableRefObject<KeenSliderInstance>
  instanceRef2?: React.MutableRefObject<KeenSliderInstance>
  instanceRef3?: React.MutableRefObject<KeenSliderInstance>
}

function SliderButton({
  dir,
  background,
  arrow,
  variation,
  disabled,
  instanceRef1,
  instanceRef2,
  instanceRef3,
}: Props) {
  const onClick = () => {
    if (instanceRef1) {
      dir === 'right'
        ? instanceRef1?.current?.next()
        : instanceRef1?.current?.prev()
    }

    if (instanceRef2) {
      dir === 'right'
        ? instanceRef2.current?.next()
        : instanceRef2.current?.prev()
    }

    if (instanceRef3) {
      dir === 'right'
        ? instanceRef3.current?.next()
        : instanceRef3.current?.prev()
    }
  }

  return (
    <button
      onClick={onClick}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
      tabIndex={0}
      disabled={disabled}
      className={classNames(style.arrowWrapper, {
        [style.arrowWrapperDark]: background === 'dark',
        [style.arrowWrapperLight]: background === 'light',
        [style.dotsBeneath]: variation === 'dots-beneath',
      })}
    >
      <div className={classNames(style.arrow, arrow === style.arrowDark)}></div>
    </button>
  )
}

export default SliderButton
